import { useTranslation } from 'next-i18next'
import React, { useState } from 'react'

import { useFeedbackStore } from '../../../functions/store'
import { FighterLabel } from './FighterLabel'

export default function Sidebar() {
  const store = useFeedbackStore((state) => state)
  const fighters = store.ratings

  const { t } = useTranslation('avaliacao360')
  const [sidebarVisible, setSidebarVisible] = useState(false)

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible)
  }

  return (
    <div id="desktopSidebar">
      <ul
        className={`sidebar-content bg-white/0 rounded-2xl text-white/80 px-0 py-3 max-h-none overflow-y-auto static top-0 left-0 opacity-100 z-50`}
      >
        <li className="h5 mb-4 pe-6 min-w-52">
          {t('evaluation.sidebar.title')}
        </li>
        {fighters &&
          fighters.map((fighter, index) => (
            <FighterLabel
              key={fighter.fighterPhone}
              fighter={{
                fighterName: fighter.fighterName,
                fighterPhone: fighter.fighterPhone,
              }}
              index={index}
            />
          ))}
      </ul>
      <button
        className={`sidebar-button w-fit bg-slate-800/95 text-slate-300 hover:bg-slate-700/80 hover:text-white h5 opacity-100 px-6 py-3 rounded-full text-white bottom-0 left-0 right-0 mx-auto z-[99999]`}
        onClick={toggleSidebar}
      >
        {sidebarVisible
          ? t('feedback.fighterCards.closeAllFighters')
          : t('feedback.fighterCards.seeAllFighters')}
      </button>

      {/* {Lista de participantes - versão mobile} */}
      {sidebarVisible && (
        <>
          <ul
            className={`sidebar-mob-content w-full bg-black/95 rounded-2xl text-black/80 p-6 pt-10 pb-4 h-screen overflow-y-scroll fixed top-0 left-0 opacity-100 z-[9999]`}
            onClick={toggleSidebar}
          >
            <li className="h4 mb-4 text-white">
              {t('evaluation.sidebar.title')}
            </li>
            {fighters &&
              fighters.map((fighter, index) => (
                <FighterLabel
                  key={fighter.fighterPhone}
                  fighter={{
                    fighterName: fighter.fighterName,
                    fighterPhone: fighter.fighterPhone,
                  }}
                  index={index}
                  isMobile
                />
              ))}
          </ul>
        </>
      )}
    </div>
  )
}
